import React from 'react';

export const GraduationCap = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 37"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.62517 19.4559V24.3624C5.62516 25.1426 5.84642 25.9068 6.26326 26.5664C6.6801 27.2259 7.27544 27.7537 7.98017 28.0884L15.4802 31.6494C16.0332 31.9122 16.6379 32.0485 17.2502 32.0485C17.8625 32.0485 18.4671 31.9122 19.0202 31.6494L26.5202 28.0884C27.2249 27.7537 27.8202 27.2259 28.2371 26.5664C28.6539 25.9068 28.8752 25.1426 28.8752 24.3624V19.4574L19.1627 24.3129C18.5689 24.61 17.9141 24.7646 17.2502 24.7646C16.5862 24.7646 15.9314 24.61 15.3377 24.3129L5.62517 19.4559Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3442 5.69043C16.9142 5.40543 17.5862 5.40543 18.1562 5.69043L31.1432 12.1839C32.6357 12.9294 32.6357 15.0594 31.1432 15.8064L18.1562 22.3014C17.5862 22.5864 16.9142 22.5864 16.3442 22.3014L3.35717 15.8064C1.86467 15.0594 1.86467 12.9294 3.35717 12.1839L16.3442 5.69043Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.7452 12.7419C29.8784 12.475 30.1123 12.2719 30.3953 12.1774C30.6783 12.0829 30.9872 12.1047 31.2542 12.2379L34.2542 13.7379C34.4409 13.8315 34.5979 13.9752 34.7076 14.153C34.8173 14.3308 34.8753 14.5356 34.8752 14.7444V19.9944C34.8752 20.2928 34.7566 20.579 34.5457 20.7899C34.3347 21.0009 34.0485 21.1194 33.7502 21.1194C33.4518 21.1194 33.1656 21.0009 32.9547 20.7899C32.7437 20.579 32.6252 20.2928 32.6252 19.9944V15.4404L30.2477 14.2509C29.9807 14.1177 29.7777 13.8838 29.6832 13.6008C29.5886 13.3178 29.6119 13.0089 29.7452 12.7419Z"
      fill="currentColor"
    />
  </svg>
);
